import React from "react";

import { Props } from "./LibraryModel";

export default function Library(props: Props) {
  const { bookId } = props.match.params;
  return <> Library {bookId && <>Current Book: {bookId}</>}</>;
}
